/**
 * What gets stored in the applications table is the name from leadSourceMap (libs/data/leadSourcesMap.ts), NOT THIS UPPERCASE ENUM
 */
export enum LeadSourceType {
  Alfalfa = 'ALFALFA',
  AltairEquifax = 'ALTAIREQUIFAX',
  AltairExperian = 'ALTAIREXPERIAN',
  AltairExperianRealtime = 'ALTAIREXPERIANREALTIME',
  AltairPreMover = 'ALTAIRPREMOVER',
  AltairTransunion = 'ALTAIRTRANSUNION',
  Agc = 'AGC',
  AgcIncentive = 'AGCINCENTIVE',
  AkcHomes = 'AKCHOMES',
  AkcHomesIncentive = 'AKCHOMESINCENTIVE',
  Amazon = 'AMAZON',
  AmazonBenefitsDemo = 'AMAZONBENEFITSDEMO',
  AnnalyLoanCare = 'ANNALYLOANCARE',
  AnnalyLoanCareMoneyOutbound = 'ANNALYLOANCAREMONEYOUTBOUND',
  AnnalyLoanCarePayoff = 'ANNALYLOANCAREPAYOFF',
  Backfill = 'BACKFILL',
  BuilderReferral = 'BUILDERREFERRAL',
  Builder = 'BUILDER',
  BuilderIncentive = 'BUILDERINCENTIVE',
  Bankrate = 'BANKRATE',
  BankrateAlfie = 'BANKRATEALFIE',
  BankrateCall = 'BANKRATECALL',
  BankrateCashOutEmail = 'BANKRATECASHOUTEMAIL',
  BankrateCPC = 'BANKRATECPC',
  BankrateDigiFlex = 'BANKRATEDIGIFLEX',
  BankrateEmail = 'BANKRATEEMAIL',
  BankrateFedEmail = 'BANKRATEFEDEMAIL',
  BankratePrimary = 'BANKRATEPRIMARY',
  BankrateSecondary = 'BANKRATESECONDARY',
  BankrateWSJ = 'BANKRATEWSJ',
  BestMoney = 'BESTMONEY',
  BestMoneyCashoutClick = 'BESTMONEYCASHOUTCLICK',
  Barcelona = 'BARCELONA',
  BarcelonaIncentive = 'BARCELONAINCENTIVE',
  Bing = 'BING',
  BorrowerPortal = 'BORROWERPORTAL',
  Confia = 'CONFIA',
  ConfiaIncentive = 'CONFIAINCENTIVE',
  ConsumerAffairs = 'CONSUMERAFFAIRS',
  CPC = 'CPC',
  CustomerReferral = 'CUSTOMERREFERRAL',
  DirectResidential = 'DIRECTRESIDENTIAL',
  DirectResidentialIncentive = 'DIRECTRESIDENTIALINCENTIVE',
  ElijahAnthony = 'ELIJAHANTHONY',
  ElijahAnthonyIncentive = 'ELIJAHANTHONYINCENTIVE',
  Encore = 'ENCORE',
  EncoreIncentive = 'ENCOREINCENTIVE',
  Earnnest = 'EARNNEST',
  EarnnestReferral = 'EARNNEST REFERRAL',
  EarnnestReferralCompact = 'EARNNESTREFERRAL',
  EmployeeLoans = 'EMPLOYEELOANS',
  ExistingCustomerReferral = 'EXISTINGCUSTOMERREFERRAL',
  Facebook = 'FACEBOOK',
  Facet = 'FACET',
  Fed = 'FED',
  FiSpoke = 'FISPOKE',
  FreeRateUpdate = 'FREERATEUPDATE',
  FullBeaker = 'FULLBEAKER',
  HarrisTeeter = 'HARRISTEETER',
  Haven = 'HAVEN',
  HavenLoanCare = 'HAVENLOANCARE',
  HelocOutbound = 'HELOCOUTBOUND',
  HomeEquityCPC = 'HOMEEQUITYCPC',
  HomeEquityPrimary = 'HOMEEQUITYPRIMARY',
  HomeEquitySecondary = 'HOMEEQUITYSECONDARY',
  HomeLight = 'HOMELIGHT',
  Hrm = 'HRM',
  HrmIncentive = 'HRMINCENTIVE',
  HSH = 'HSH',
  ICanBuy = 'ICANBUY',
  KbbHomes = 'KBBHOMES',
  InboundCall = 'INBOUNDCALL',
  LeadPointPosted = 'LEADPOINTPOSTED',
  Lendgo = 'LENDGO',
  LendingTree = 'LENDINGTREE',
  LoanEstimateComparison = 'LOANESTIMATECOMPARISON',
  LowerMyBills = 'LOWERMYBILLS',
  LowerMyBillsShortForm = 'LOWERMYBILLSSHORTFORM',
  MilitaryVALoan = 'MILITARYVALOAN',
  MoneyGroup = 'MONEYGROUP',
  Moonshot = 'MOONSHOT',
  MortgageLenderComparisonCashOutRefiClick = 'MORTGAGELENDERCOMPARISONCASHOUTREFICLICK',
  MyAgentFinder = 'MYAGENTFINDER',
  NaturalIntelligence = 'NATURALINTELLIGENCE',
  NaturalIntelligencePurchaseRefi = 'NATURALINTELLIGENCEPURCHASEREFI',
  NerdWallet = 'NERDWALLET',
  NerdwalletPurchase = 'NERDWALLETPURCHASE',
  NerdwalletRefinance = 'NERDWALLETREFINANCE',
  NerdWalletRateTablePurchase = 'NERDWALLETRATETABLEPURCHASE',
  NerdWalletRateTableRefinance = 'NERDWALLETRATETABLEREFINANCE',
  PersonalReferral = 'PERSONALREFERRAL',
  PropertyMate = 'PROPERTYMATE',
  Puma = 'PUMA:UI',
  PurchaseReferrals = 'PURCHASEREFERRALS',
  RateZip = 'RATEZIP',
  RealtorReferral = 'REALTORREFERRAL',
  Refily = 'REFILY',
  RetClientForLifeOB = 'RETCLIENTFORLIFEOB',
  Reporting = 'REPORTING',
  Robinhood = 'ROBINHOOD',
  RobinhoodConcierge = 'ROBINHOODCONCIERGE',
  RobinhoodSummit = 'ROBINHOODSUMMIT',
  RuthandRandall = 'RUTHANDRANDALL',
  RuthandRandallIncentive = 'RUTHANDRANDALLINCENTIVE',
  RVMN = 'RVMN',
  SageMortgageEmail = 'SAGEMORTGAGEEMAIL',
  SageRadio = 'SAGERADIO',
  SageWebsite = 'SAGEWEBSITE',
  SantoriniProperty = 'SANTORINI_PROPERTY',
  SantoriniPropertyIncentive = 'SANTORINI_PROPERTY_INCENTIVE',
  Schemathics = 'SCHEMATHICS',
  SEM = 'SEM',
  Sims = 'SIMS',
  SMARTASSET = 'SMARTASSET',
  SupportPhoneNumber = 'SUPPORTPHONENUMBER',
  TheMortgageReport = 'THEMORTGAGEREPORT',
  Top10 = 'TOP10',
  Transunion = 'TRANSUNION',
  Unmapped = 'UNMAPPED',
  USNews = 'USNEWS',
  WhiteTree = 'WHITETREE',
  WhiteTreeIncentive = 'WHITETREEINCENTIVE',
  YearyHauco = 'YEARYHAUCO',
  YearyHaucoIncentive = 'YEARYHAUCOINCENTIVE',
  Ownup = 'OWNUP',
  OwnupExperianTriggers = 'OWNUPEXPERIANTRIGGERS',
  Zillow = 'ZILLOW',
}
